// extracted by mini-css-extract-plugin
export default {"header-content":"layout_header-content__tapG2"};